(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["certificate-verification"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.mntCertificateVerificationListener) return;
    window.mntCertificateVerificationListener = true;

    const allowedOrigins = new Set([
      'https://script.google.com',
      'https://script.googleusercontent.com'
    ]);

    window.addEventListener('message', (event) => {
      if (!allowedOrigins.has(event.origin) || !event.data || event.data.source !== 'mnt-certificate-portal') return;

      if (event.data.event === 'mnt_portal_resize') {
        const requestedHeight = Number(event.data.payload && event.data.payload.height);
        if (!Number.isFinite(requestedHeight)) return;

        document.querySelectorAll('[data-mnt-verification-frame]').forEach((frame) => {
          if (frame.contentWindow !== event.source) return;
          frame.style.height = `${Math.min(Math.max(requestedHeight + 8, 680), 4200)}px`;
        });
        return;
      }

      const payload = event.data.payload || {};
      if (typeof window.gtag === 'function') window.gtag('event', event.data.event, payload);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: event.data.event, ...payload });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
